import { render, staticRenderFns } from "./StudyRecordCoursesList.vue?vue&type=template&id=e8573a9a"
import script from "./StudyRecordCoursesList.vue?vue&type=script&lang=js"
export * from "./StudyRecordCoursesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports